import React from "react"
import styled from "styled-components"
import Tooltip from "./Tooltip/Tooltip"

interface Props {
	tooltipText: string
}

const InfoBubble = ({ tooltipText }: Props) => {
	return (
		<>
			<Base className="center-x-y non-draggable" data-for="InfoBubble-i" data-tip={tooltipText}>
				i
			</Base>

			<Tooltip id="InfoBubble-i" html={true} type="dark" />
		</>
	)
}

export default InfoBubble

const Base = styled.div`
	width: 21px;
	height: 21px;
	border: 1px solid var(--blue);
	border-radius: 50%;

	color: var(--blue);
	font-size: 14px;
`
